import React from 'react'
import {FacilityImage} from '../../facilities/FacilityForReservation'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors, FontSize, FontSizeInPixel, FontWeights} from '../../../styledComponents/Constants'
import {getFacilityCategoryImageUrl} from '../../facilities/FacilityCategoryImageHelper'
import {FACILITY_CATEGORY} from '../../../CodeMaster'
import ImageGallery, {ReactImageGalleryItem} from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import './Carousel.css'

import {
    BlockSpacer,
    BlockSpacerPcOnly,
    BlockSpacerSpOnly,
    GridContainer,
    GridItem,
    RenderSwitchByBreakPoint,
} from '../../../styledComponents/ResponsiveConvenience'
import CollapseHTMLDisplay from '../components/CollapseHTMLDisplay'
import {
    FullWidthLeftColumnFlexContainer,
    LeftRowFlexContainer
} from '../../../styledComponents/FlexComponents'

interface Props {
    facilityName?: string
    facilityIntroductory: string
    facilityImages: FacilityImage[]
    facilityCategory: FACILITY_CATEGORY
    openFacilityIntroductory?: boolean
}

const RRFFFacilityInformation: React.FC<Props> = (props) => {
    const facilityImages: FacilityImage[] =
        getFacilityImagesUpdateByCategoryImage(props.facilityImages, props.facilityCategory)

    const images = [...facilityImages]
        .sort((a, b) => a.displayOrder - b.displayOrder)
        .map((image) => {
            return {
                original: image.uri,
                thumbnail: image.uri,
            }
        })
    const initialOpen: boolean =
        (props.openFacilityIntroductory === undefined)
            ? true
            : props.openFacilityIntroductory

    return (
        <>
            <GridContainer alignItems={'flex-start'}>
                <GridItem over={5}>
                    <RenderSwitchByBreakPoint
                        under={<CarouselForSP images={images}/>}
                        over={<CarouselForPC images={images}/>}
                    />
                </GridItem>
                <GridItem over={7}>
                    <BlockSpacerSpOnly height={'15px'}/>
                    <LeftRowFlexContainer>
                        <BlockSpacerPcOnly ml={'15px'}/>
                        <FullWidthLeftColumnFlexContainer>
                            {
                                props.facilityName &&
                                <>
                                    <FacilityName>{props.facilityName}</FacilityName>
                                    <BlockSpacer height={'15px'}/>
                                </>
                            }
                            <RenderSwitchByBreakPoint
                                under={
                                    <CollapseHTMLDisplay
                                        showScroll={false} initialOpen={initialOpen}
                                        maxDisplayLines={5}
                                        fontSizeInPixel={FontSizeInPixel.Body}
                                        lineHeightInPixel={FontSizeInPixel.Big}
                                        contents={props.facilityIntroductory}
                                    />
                                }
                                over={
                                    <CollapseHTMLDisplay
                                        showScroll={true} initialOpen={true}
                                        maxDisplayLines={13}
                                        fontSizeInPixel={FontSizeInPixel.Body}
                                        lineHeightInPixel={FontSizeInPixel.Big}
                                        contents={props.facilityIntroductory}
                                    />
                                }
                            />
                        </FullWidthLeftColumnFlexContainer>
                    </LeftRowFlexContainer>
                </GridItem>
            </GridContainer>
        </>
    )
}

const CarouselForPC: React.FC<{ images: ReactImageGalleryItem[] }> = props =>
    <ImageGallery
        items={props.images} showPlayButton={false} infinite={false}
        showThumbnails={props.images.length > 1}
    />

const CarouselForSP: React.FC<{ images: ReactImageGalleryItem[] }> = props =>
    <ImageGallery
        items={props.images} showPlayButton={false} infinite={false}
        showThumbnails={false}
        showFullscreenButton={false}
    />

const getFacilityImagesUpdateByCategoryImage = (
    facilityImages: FacilityImage[],
    facilityCategory: FACILITY_CATEGORY,
): FacilityImage[] => {
    if (facilityImages.length > 0) {
        return [...facilityImages]
    }

    const facilityCategoryImage: FacilityImage = {
        uri: getFacilityCategoryImageUrl(facilityCategory),
        displayOrder: 0,
    }
    return [facilityCategoryImage]
}

RRFFFacilityInformation.displayName = 'RRFFFacilityInformation'
export default RRFFFacilityInformation

const FacilityName: StyledDiv = styled.div`
  width: 100%;
  font-size: ${FontSize.Big};
  line-height: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`
